import { fetch } from '../request';
export const getSceneDetails = () => {
  const route = useRoute();
  return fetch('/material/youyan_config/map_detail/', {
    method: 'GET',
    params: { identity: route.query.look_name },
  });
};

export const getStudioDetails = (identity: string) => {
  return fetch('/material/youyan_config/map_detail/', {
    method: 'GET',
    params: { identity },
  });
};
